export const stagingConfig = {
  apiKey: "AIzaSyBqERl3sypP5hujEQvYdDJlkuB2N-hM4t0",
  authDomain: "nomp-staging.firebaseapp.com",
  projectId: "nomp-staging",
  storageBucket: "nomp-staging.firebasestorage.app",
  messagingSenderId: "856431008964",
  appId: "1:856431008964:web:4fd704004588ebc7063d91",
};
